<template>
  <div>
    <el-dialog
      custom-class="real-dialog"
      title="关于版本"
      :visible="dialogVisible"
      width="800px"
      @close="handleClose"
      append-to-body
      center>
      <el-image :src="require('@/assets/img/nodata.png')" alt="" style="display: block; width: 300px; margin: 0 auto;" v-if="versionList.length === 0"></el-image>
      <el-timeline v-else>
        <el-timeline-item  v-for="(v, i) in versionList" :key="i" :timestamp="v.Version" placement="top">
          <el-card class="time-notice-list">
            <h3>{{v.VersionName}}</h3>
            <ul>
              <li v-for="(val, index) in v.updateContentArray" :key="index">{{val}}</li>
            </ul>
            <p>{{v.UpdateTime}}</p>
          </el-card>
        </el-timeline-item>
      </el-timeline>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="handleClose">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import showdialog from '../../../minxs/showdialog'
import { listUpdateVersion } from "@/api/module/tenant";
import { getTenantId } from "@/utils/service";
import { distinguishTitle } from "@/utils/index";

export default {
  data() {
    return {
      param: {
        RequestProduct: 4,
        Product: 4,
        Page: 1,
        PerPage: 1,
      },
      versionList: [],
    };
  },
  mixins:[showdialog],
  mounted() {
  },
  watch: {
    dialogVisible(v) {
      if (v) {
        this.param.TenantId = Number(getTenantId());
        this.param.RequestProject = this.ProjectObj[distinguishTitle()];
        this.param.Project = this.ProjectObj[distinguishTitle()];
        this.getSetting();
      }
    },
  },
  methods: {
    getSetting() {
      listUpdateVersion(this.param).then((res) => {
        if (res.state === "success") {
          this.versionList = res.data;
        } else {
          this.$message.error(res.message);
        }
      })
    },
  }
};
</script>

<style lang="scss" scoped>
  .time-notice-list{
    ul{
      margin-bottom: 10px;
      padding-left: 20px;
      line-height: 2;
      li{
        padding-left: 10px;
        position: relative;
        &:before{
          content: '·';
          position: absolute;
          font-size: 30px;
          left: -4px;
          top: -16px;
        }
      }
    }
    p{
      color: #999;
    }
  }
</style>
